import classnames from 'classnames';
import { isValidElement, MouseEvent, ReactElement, ReactNode } from 'react';

import styles from './searchResult.module.scss';

type SearchResultContentProps = {
  avatar: ReactNode;
  message: ReactNode;
  title: ReactNode;
};

type SearchResultProps = {
  className?: string;
  content: SearchResultContentProps | ReactElement;
  onClick?: (event: MouseEvent<HTMLDivElement>) => void;
};

/**
 * Represents a component that is used to render a single result on the search
 * results sidebar
 */
export const SearchResult = ({
  className,
  content,
  onClick,
}: SearchResultProps): JSX.Element => {
  const renderContent = (): JSX.Element => {
    if (isValidElement(content)) {
      return content;
    }

    const { avatar, message, title } = content as SearchResultContentProps;

    return (
      <>
        <div className={styles.avatar}>{avatar}</div>

        <div className={styles.resultContent}>
          <div className={styles.title}>{title}</div>
          <div className={styles.message}>{message}</div>
        </div>
      </>
    );
  };

  return (
    <div className={classnames(styles.result, className)} onClick={onClick}>
      <div className={styles.resultCenter}>{renderContent()}</div>
    </div>
  );
};
